import Constants from '~/app/Constants';

export default function getFaviconPath(exp: string) {
  switch (exp) {
    case Constants.DealersExperience.acura:
      return 'Media/acura/favicon.ico';
    case Constants.DealersExperience.genesis:
      return 'Media/genesis/favicon.ico';
    case Constants.DealersExperience.honda:
      return 'Media/honda/favicon.ico';
    case Constants.DealersExperience.hyundai:
      return 'Media/hyundai/favicon.ico';
    default:
      return 'Media/favicon.ico';
  }
}
